import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import { getCmdbRestBaseUrl } from './getCmdbRestBaseUrl.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token/${type}?label=${label}&duration=${duration}
 */
export const getDataManagerGenerateContainerTokenUrl = (
	workspaceId: WorkspaceId,
	label: string,
	type: string,
	duration: string,
): string =>
	`${getCmdbRestBaseUrl(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;

/**
 * POST /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token/${type}
 */
export const postDataManagerGenerateContainerTokenUrl = (
	workspaceId: WorkspaceId,
	type: string,
): string => `${getCmdbRestBaseUrl(workspaceId)}/data-manager/token/${type}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token/${tokenId}
 */
export const delDataManagerContainerTokenUrl = (
	workspaceId: WorkspaceId,
	tokenID: string,
): string => `${getCmdbRestBaseUrl(workspaceId)}/data-manager/token/${tokenID}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token
 */
export const getDataManagerFetchContainerTokenUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbRestBaseUrl(workspaceId)}/data-manager/token`;

/**
 * /gateway/api/jsm/data-manager/workspace/${workspaceId}/app/config/sync/provisioningstatus
 */
export const getDataManagerProvisioningStatusUrl = (workspaceId: WorkspaceId): string =>
	`${getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;

/**
 * /gateway/api/jsm/data-manager/workspace/${workspaceId}/app/config/permission/data-manager-users
 */
export const getDataManagerUserSearchUrl = (workspaceId: WorkspaceId): string =>
	`${getAirtrackAppRestBaseUrl(workspaceId)}/config/permission/data-manager-users`;

/**
 * /gateway/api/jsm/data-manager/workspace/${workspaceId}/app/config/permission/role-assignment
 */
export const getDataManagerRoleAssignmentUrl = (workspaceId: WorkspaceId): string =>
	`${getAirtrackAppRestBaseUrl(workspaceId)}/config/permission/role-assignment`;

/**
 * /gateway/api/jsm/data-manager/workspace/${workspaceId}/app/config/permission/principal
 */
export const getDataManagerPrincipalUrl = (workspaceId: WorkspaceId): string =>
	`${getAirtrackAppRestBaseUrl(workspaceId)}/config/permission/principal`;

const getAirtrackAppRestBaseUrl = (workspaceId: WorkspaceId) =>
	`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;
